import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Card, CardContent } from '@/components/ui/card';
    import { cn } from '@/lib/utils';
    import type { HTMLAttributes } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PageCard',
  props: {
    class: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), {
    class: _normalizeClass(_unref(cn)('m-1.5 min-h-0 flex-1', props.class))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(CardContent), { class: "h-full" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})